import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { IonicModule } from '@ionic/angular';
import { HelpValidationPopupComponent } from './components/validation-popup/help-validation-popup.component';

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.HELP,
  i18nLabel: 'MODULES.HELP',
  icon: 'help',
  leftMenuAvailableForPages: [0, 1, 2, 3],
  routes: [
    {
      path: 'help',
      loadChildren: () =>
        import('./pages/help/help.module').then(m => m.HelpPageModule)
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './help/i18n/', multi: true }
  ],
  declarations: [HelpValidationPopupComponent],
  exports: [HelpValidationPopupComponent]
})
export class HelpModule {}
